import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { AppService } from "@root/app.service";
import { roomTypesDoc } from "@root/config";

@Component({
  selector: "host-link-room-type-note",
  templateUrl: "./link-room-type-note.component.html",
  styleUrls: ["./link-room-type-note.component.scss"],
})
export class LinkRoomTypeNoteComponent implements OnInit {
  @Output() onClose = new EventEmitter();
  @Output() onFinish = new EventEmitter();
  private get isInternational() {
    return this.app.app.international;
  }

  get roomTypesDoc() {
    return roomTypesDoc(this.isInternational);
  }

  step = 1;

  constructor(private app: AppService) {}

  ngOnInit() {}

  onClickClose() {
    this.onClose.emit();
  }

  onClickFinish() {
    this.onFinish.emit();
  }
}
